import { Loader2, Mail } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { useManageUserPageData } from "../hooks";

const ManageUserFooter = observer(() => {
  const { t } = useTran();
  const { userId } = useParams();
  const {
    statusValue,
    statusLabel,
    statusVariant,
    sendingReset,
    saving,
    handlePasswordReset,
  } = useManageUserPageData({ userId });

  return (
    <CardFooter className="flex flex-col gap-3 pt-0 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {t("Current status:")}
        {statusValue ? (
          <Badge variant={statusVariant} className="uppercase">
            {statusLabel}
          </Badge>
        ) : (
          <span>{t("Not set")}</span>
        )}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button
          type="button"
          variant="outline"
          className="gap-2"
          onClick={handlePasswordReset}
          disabled={sendingReset}
        >
          {sendingReset ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Mail className="h-4 w-4" />
          )}
          {sendingReset ? t("Sending...") : t("Send password reset")}
        </Button>
        <Button
          type="submit"
          form="manage-user-form"
          disabled={saving}
          className="gap-2"
        >
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          {saving ? t("Saving...") : t("Save changes")}
        </Button>
      </div>
    </CardFooter>
  );
});

export default ManageUserFooter;
